import { AuthProvider } from 'react-admin'
import {
  extractPermisionSubmenu,
  getLocalUserInfo,
  login as loginUser,
  logout as logoutUser,
  refreshUserInfo,
  removeUser,
  setUser,
} from '../../utils/user'
import { Permissions, UserInfoOnUI } from '../../utils/user/type'
import tokenManager from '../../utils/token'

const initAuthProvider = (): AuthProvider => {
  return {
    login: async ({ username, password }): Promise<void> => {
      try {
        const response = await loginUser({ username, password })
        if (response.status < 200 || response.status >= 300) {
          throw new Error(response?.data?.message ?? 'Invalid email or password')
        }
        tokenManager.setToken(response.data.result)
      } catch (error) {
        throw new Error(error?.response?.data?.message ?? error?.message ?? 'Invalid email or password')
      }
    },
    checkError: (error): Promise<void> => {
      const status = error.status || error.response.status
      if (status === 401) {
        tokenManager.removeToken()
        removeUser()
        return Promise.reject()
      }

      return Promise.resolve()
    },
    checkAuth: async (): Promise<void> => {
      const token = tokenManager.getToken()
      const isTokenExpired = tokenManager.isTokenExpired()
      if (token != null && isTokenExpired) {
        Promise.reject({ message: 'ra.auth.auth_check_error' })
      }
      await tokenManager.validateToken()
    },
    logout: async (): Promise<string | false | void> => {
      await logoutUser().catch(e => console.error(e))
      tokenManager.removeToken()
      removeUser()
      return '/login'
    },
    getIdentity: async (): Promise<UserInfoOnUI> => {
      try {
        let userInfo = getLocalUserInfo()
        const token = tokenManager.getToken()
        const isTokenExpired = tokenManager.isTokenExpired()
        if (token != null && isTokenExpired) {
          await tokenManager.validateToken()
        }
        if (!userInfo) {
          userInfo = await refreshUserInfo()
        }
        return Promise.resolve(userInfo)
      } catch (error) {
        return Promise.reject(error)
      }
    },
    getPermissions: async (): Promise<Permissions> => {
      const userInfo = getLocalUserInfo()
      const permissions = userInfo && userInfo.role ? userInfo.role.permissions : null
      if (!permissions) return Promise.reject()
      return extractPermisionSubmenu(permissions)
    },
    setIdentityUser: (userData: UserInfoOnUI): UserInfoOnUI => {
      return setUser(userData)
    },
  }
}

export default initAuthProvider
